import { Component } from '@angular/core';
import { DropdownComponent } from '../../ui/dropdown/dropdown.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DropdownItemTwoComponent } from '../../ui/dropdown/dropdown-item/dropdown-item.component-two';
import { LoginService } from '../../../services/login.service';
import { AvatarTextComponent } from '../../ui/avatar/avatar-text.component';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  imports:[CommonModule,RouterModule,DropdownComponent,DropdownItemTwoComponent,AvatarTextComponent]
})
export class UserDropdownComponent {
  isOpen: boolean = false;
  fullName: string = '';
  shortName: string = '';
  email: string = '';

  constructor(private router: RouterModule, private loginService: LoginService) { }

  ngOnInit() {
    this.loginService.getUserAttributes().subscribe(
      details => {
        this.fullName = details?.username || '';
        this.shortName = details?.username || '';
        if (details?.name) {
          this.fullName = details?.name || '';
          this.shortName = details?.firstName || '';
          this.email = details?.email || '';
        }
      }
    );
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  signOut() {
    this.loginService.logout();
  }

  returnToClassicVersion() {
    this.closeDropdown();
    document.cookie = 'preferNewSite=; path=/; domain=.weriseabove.org; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    this.loginService.getSessionTokens().subscribe(tokens => {
      if (tokens) {
        const { idToken, accessToken, refreshToken } = tokens;
        const returnTo = window.location.pathname;
        const params = new URLSearchParams({ idToken, accessToken, refreshToken, returnTo });
        window.location.href = `${environment.legacySiteUrl}#transfer?${params}`;
      } else {
        window.location.href = environment.legacySiteUrl;
      }
    });
  }
}
